import { config } from './lib/supabase';
import { projectLabel } from './lib/config';
import { useSession } from './auth/session';
import { SignIn } from './auth/SignIn';
import { Shell } from './shell/Shell';
import { Pieces } from './pages/Pieces';
import { useRoute } from './lib/router';
import './app.css';

// Signed out: the sign-in screen (Phase 5a). Signed in: the app (Phase 5b).
// /pieces: every shared piece on invented books (Phase 5c).

export function App() {
  const { session, ready } = useSession();
  const { path } = useRoute();
  // The Pieces page (Phase 5c) opens with or without signing in: invented books only.
  if (path === '/pieces') return <Pieces />;
  if (!ready) return null;
  if (session) return <Shell email={session.user.email ?? ''} userId={session.user.id} />;

  return (
    <main class="auth-frame">
      <section class="auth-panel">
        <h1>Reading List</h1>
        <SignIn />
      </section>
      <p class="auth-fine">Database: {projectLabel(config)}</p>
    </main>
  );
}
